// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__9IMZk","header":"MessagesList_header__3ilp5","chat":"MessagesList_chat__3j9B7"};